export default __webpack_public_path__ + "static/media/unstaking-step-three-rosn.ae9ddf6d.svg";